import { LucideIcon } from "lucide-react";
import { SettingsItem } from "./settings-item";

export interface SettingItem {
  icon: LucideIcon;
  label: string;
  subtitle: string;
  action: () => void;
  toggle?: boolean;
  value?: boolean;
  /** When true, row is non-interactive (e.g. feature not shipped yet). */
  disabled?: boolean;
  variant?: "default" | "destructive";
}

interface SettingsSectionProps {
  title: string;
  items: SettingItem[];
}

export function SettingsSection({ title, items }: SettingsSectionProps) {
  return (
    <div>
      <h2 className="text-sm font-medium text-muted-foreground mb-3 px-2">
        {title}
      </h2>
      <div className="bg-card rounded-xl shadow-sm border border-border overflow-hidden">
        {items.map((item, index) => (
          <SettingsItem
            key={`${item.label}-${index}`}
            {...item}
            showBorder={index !== items.length - 1}
          />
        ))}
      </div>
    </div>
  );
}
